import Image from "next/image";
import React from "react";

interface ChatWithUsProps {
  phoneNumber: string;
  whatsappMessage: string;
}

const ChatWithUs: React.FC<ChatWithUsProps> = ({
  phoneNumber,
  whatsappMessage,
}) => {
  const waLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <a
      href={waLink}
      target="_blank"
      className="flex items-center justify-center mt-0 bg-[#2A85FF] border border-[#39F] rounded-3xl md:py-[5px] md:px-5 px-2 py-[6px] w-full text-white md:text-sm text-xs font-bold md:mt-4 cursor-pointer"
    >
      <Image
        src="https://ik.imagekit.io/mileseducation/miles_website/contact-us/whatsapp.webp"
        alt="whatsapp"
        className="mr-2"
        width={16}
        height={16}
        loading="lazy"
      />
      Chat with us
    </a>
  );
};

export default ChatWithUs;
